import React from 'react'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import ControlledModal from 'components/Modal/ControlledModal'
import AuthTos from 'components/Auth/AuthTos/AuthTos'

const AuthTosModal = () => {
    return (
        <ControlledModal
            name="auth-tos-modal"
            context="authTosModal"
            requireUserInput={false}
            closeOnRouteChange={false}
        >
            {() => (
                <AuthTos />
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(AuthTosModal)
